import React, { MouseEvent } from 'react'
import {
  AuditRecord,
  ReportType,
} from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { useSetActiveModal } from 'src/Modal/ModalStateContext'
import { Report } from '@trustero/trustero-api-web/lib/audit/audit_pb'
import { BasicDropdownMenuItem } from 'src/components/Reusable/BasicDropdown/BasicDropdown.styles'
import {
  ModalFormId,
  useConfirmationModal,
} from '../../../../components/ModalForms'
import { useAudit } from '../../../../components/async/model/audit'

const hasFinalPapers = (audit?: AuditRecord): boolean =>
  audit
    ?.getReportsList()
    ?.some(
      (report: Report) =>
        report.getType() === ReportType.CLOSED_AUDIT_FINAL_PAPERS,
    ) || false

export const UploadFinalReport = ({
  eventKey,
  auditId,
}: {
  eventKey: string
  auditId: string
}): JSX.Element => {
  const { data: audit } = useAudit(auditId)
  const openModal = useSetActiveModal(ModalFormId.ADD_CLOSED_AUDIT_FINAL_REPORT)
  const confirmation = useConfirmationModal({
    title: 'Replace Your Existing Final Report?',
    body: 'You have already uploaded a Final report for this audit period. This one will replace the old one.',
    confirmText: 'Continue and Upload New Final Report',
    handleSubmit: openModal,
  })

  const handleClick = (e: MouseEvent) => {
    e.preventDefault()
    hasFinalPapers(audit) ? confirmation() : openModal()
  }

  return (
    <>
      <BasicDropdownMenuItem eventKey={eventKey} onClick={handleClick}>
        Upload Final Report
      </BasicDropdownMenuItem>
    </>
  )
}
